<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useThemeStore } from './stores/theme'
import { PWABanner } from './components/ui'
import { Toaster } from 'vue-sonner'
import 'vue-sonner/style.css'

const themeStore = useThemeStore()
const showDebug = ref(false)

onMounted(() => {
  themeStore.initTheme()
  
  // Mostrar info de debug na URL
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has('debug')) {
    showDebug.value = true
  }
  
  console.log('[App] Iniciado')
  console.log('[App] Porta:', window.location.port)
  console.log('[App] Token:', !!localStorage.getItem('kardapio-token'))
})
</script>

<template>
  <div :class="themeStore.themeClasses" class="min-h-screen transition-colors duration-300">
    <RouterView />
    <PWABanner />
    <Toaster 
      position="top-right" 
      rich-colors 
      :toast-options="{
        style: {
          fontFamily: 'inherit'
        }
      }"
      class="z-[9999]"
    />
    
    <!-- Debug Info -->
    <div 
      v-if="showDebug" 
      class="fixed bottom-4 left-4 p-4 bg-black/80 text-white text-xs font-mono rounded-lg z-50 max-w-md"
    >
      <h3 class="font-bold mb-2">Debug Info</h3>
      <p>Porta: {{ window?.location?.port }}</p>
      <p>Path: {{ window?.location?.pathname }}</p>
      <p>Token: {{ localStorage.getItem('kardapio-token') ? 'Sim' : 'Não' }}</p>
      <p>Redirect Count: {{ localStorage.getItem('kardapio-redirect-count') }}</p>
    </div>
  </div>
</template>

<style>
/* Global styles */
#app {
  min-height: 100vh;
}

/* Fix vue-sonner styles */
[data-sonner-toaster] {
  position: fixed !important;
  z-index: 9999 !important;
}

[data-sonner-toaster][data-position="top-right"] {
  top: 16px !important;
  right: 16px !important;
  left: auto !important;
  bottom: auto !important;
}
</style>
